export function getLayerIndex(stackupLayers, layer) {
    if (layer === "Top" || layer === "Bottom") {
        return stackupLayers.findIndex((stackupLayer) => stackupLayer.material === "Copper" && stackupLayer.orientation === layer);
    }
    else {
        return stackupLayers.findIndex((stackupLayer) => stackupLayer.material === "Copper" && stackupLayer.name === layer);
    }
}
//# sourceMappingURL=getLayerIndex.js.map